import { userApi, myFilesApi } from '../../api'

const getDefaultState = () => {
  return {
    token: '',
    name: '',
    avatar: '',
    userId: '',
    userInfo: {},
    mySetting: ''
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_USERID: (state, userId) => {
    state.userId = userId
  },
  SET_MY_SETTING: (state, mySetting) => {
    state.mySetting = mySetting
  },
}

const actions = {
  // 获取用户信息
  getUserInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      userApi.getUserInfo().then(response => {
        const { userInfo } = response
        if (!userInfo) {
          return reject('未获取token，获取用户信息失败！')
        }
        const fullName = `${userInfo.realName}-${userInfo.dept}`
        userInfo.fullName = fullName
        const { realName, avatar, userId } = userInfo
        commit('SET_NAME', realName)
        commit('SET_AVATAR', avatar)
        commit('SET_USERID', userId)
        commit('SET_USERINFO', userInfo)
        resolve(userInfo)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 获取我的配置
  getMySetting ({ commit }) {
    return new Promise((resolve, reject) => {
      myFilesApi.getMySetting().then(response => {
        const { data } = response
        console.log(data);
        commit('SET_MY_SETTING', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

